import type { Reducer, Effect } from 'umi'
import { history } from 'umi'
import { stringify } from 'querystring'
import { loadPlugins } from '@xiaoduo/plugin_sdk'
import priCenterSdk from '@xiaoduo/pricentersdk'
import { getMenuState } from '@/utils/route'
import { getPageQuery, whiteList, isTest } from '@/utils/utils'
import * as services from '@/services/user'
import { loginSensors } from '@/utils/sensorsData'
import initPlugin from '@/plugin'

export type LoginResult = {
  platform: string
  avatar: string
  id: string
  name: string
  username: string
  role: {
    name: string
  }
}

export type UserModelState = {
  payUrl: string //  购买链接
  cgate_token: string
  platform: string
  avatar: string
  id: string
  name: string
  username: string
  role: {
    name: string
  }
  root: boolean
  features: string[]
  version_code: string
  en_agent_tenant_id: string
  industry_category: string
  initialCompleted: boolean
  xqc_company_id: string
  hasVoc: boolean
  standard_tenant_id: string
  enterprise: object
  payType: string
  uc_token: string
  agent_cloud: number
  robot: number
  agent_id: string
  agentList: any[]
  cgateToken: any
  toolList: any[]
  userGroups: any[]
  schema_definition: any[]
}

export type UserModelType = {
  namespace: 'user'
  state: UserModelState
  effects: {
    fetchUserInfo: Effect
    login: Effect
    logout: Effect
    updateUserName: Effect
    updatePassword: Effect
    switchPlatform: Effect
    industryCategory: Effect
    initUserOnce: Effect
    bindXHMC: Effect
    resetPass: Effect
    enterprise: Effect
    fecthPayUrl: Effect
    getUcToken: Effect
    unBind: Effect
    presetTask: Effect
    fetchCgateToken: Effect
    agentBind: Effect
    fetchTrainData: Effect
    queryTools: Effect
    getPlugin: Effect
    getMetadataAndGroups: Effect
  }
  reducers: {
    setState: Reducer<UserModelState>
  }
}
export const appHubUrl = isTest ? 'https://www-dev-lane.xiaoduoai.com' : 'https://www.xiaoduoai.com'

const fetchPayUrl = ({ url, data, header }) => {
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      ...header,
    },
    credentials: 'include',
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((error) => console.error('Error:', error))
}

const fetchUser = ({ url, data, method, header = '' }) => {
  if (method === 'post') {
    return fetch(url, {
      method: 'post',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .catch((err) => console.log(err, 'err'))
  } else if (method === 'get') {
    // 获取多策agent列表
    return fetch(url, {
      method: 'get',
      headers: {
        'xiaoduo-enid': header,
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err, 'err'))
  }
}

const UserModel: UserModelType = {
  namespace: 'user',
  state: {
    payUrl: '',
    cgate_token: '',
    platform: 'tb',
    avatar: '',
    id: '',
    name: '',
    username: '',
    role: {
      name: '',
    },
    root: false,
    features: [], // 产品管理后台权限
    version_code: '',
    en_agent_tenant_id: '',
    industry_category: undefined,
    initialCompleted: false,
    xqc_company_id: '',
    hasVoc: false,
    standard_tenant_id: '', //晓总管id
    enterprise: {}, //流量信息
    payType: '', //充值类型
    uc_token: '',
    agent_cloud: 0, // 判断是否开通多策 0未开通 1使用中 2已过期 3无权限 4未绑定
    robot: 0, // 判断是否开通机器人 0未开通 1使用中 2已过期 3无权限 4未绑定
    agent_id: '', //多策id
    agentList: [],
    cgateToken: {}, // 请求机器人的token
    toolList: [], // 训练场工具列表
    userGroups: [], // 用户组列表
    schema_definition: [], // 企业定义筛选条件
  },
  effects: {
    *fetchUserInfo(_, { call, put }) {
      initPlugin()
      const response = yield call(services.fetchUserInfo)

      if (response?.data?.pri_center_token) {
        try {
          const { code, data } = yield priCenterSdk.init({
            token: response.data.pri_center_token,
            host: isTest ? '//console-dev-lane.xiaoduoai.com' : '//console.xiaoduoai.com',
            appId: 'barracks',
            // host: '//console-mini-test-mini-cond.1yangai.com',
          }) || {}
          if (code === 0) {
            yield put({
              type: 'setState',
              payload: {
                features: data?.features || [],
                version_code: data?.version_code || '',
              },
            })
          }
        } catch (error) {
          console.error('priCenterSdk init error', error)
        }
      }

      let hasVoc
      if (response?.data?.xqc_pri_center_token) {
        let data
        try {
          const { code: CODE, data: DATA } = yield priCenterSdk.init({
            token: response.data.xqc_pri_center_token,
            host:
              window.location.host?.startsWith('localhost') ||
              window.location.host?.startsWith('training-dev-lane')
                ? '//console-dev-lane.xiaoduoai.com'
                : '//console.xiaoduoai.com',
            appId: 'mc',
            // host: '//console-mini-test-mini-cond.1yangai.com',
          })
          if (CODE === 0) {
            data = DATA
          }
        } catch (error) {}
        hasVoc = data?.features?.some((i) => i.indexOf('voc') != -1)
      } else {
        hasVoc = false
      }

      yield put({
        type: 'setState',
        payload: {
          ...response.data,
          role: { name: response.data.role },
          hasVoc,
        },
      })
      yield put({ type: 'global/updateMenu' })

      if (whiteList(response?.data?.tenant_id)) {
        const res = yield call(services.getGroups)
        yield put({
          type: 'setState',
          payload: {
            userGroups: res?.data?.user_groups?.map((group) => group.id) || [],
          },
        })
      }

      loadPlugins(`tenant_id=${response.data.en_agent_tenant_id}`)
      if (response?.data.en_staff_id) {
        yield put({
          type: 'getUcToken',
          payload: {
            en_staff_id: response.data.en_staff_id,
            expires_in: 36000,
          },
        })
      }

      if (response.data?.standard_tenant_id) {
        yield put({
          // 获取流量信息
          type: 'enterprise',
          payload: {
            product_key: 'barracks',
            scalar_type: 'recharge_mode',
            enterprise_id: response.data?.standard_tenant_id,
            model: 1,
          },
        })

        if (response.data?.agent_cloud === 0) {
          // 获取多策agent列表
          const res = yield call(fetchUser, {
            url:
              window.location.host?.startsWith('localhost') ||
              window.location.host?.startsWith('dev.lane.xiaoduoai.com') ||
              window.location.host?.startsWith('training-dev-lane')
                ? 'https://agent-cloud-dev.xiaoduoai.com/v1/admin/share/list?limit=10&offset=0'
                : 'https://agent-cloud.xiaoduoai.com/v1/admin/share/list?limit=10&offset=0',
            data: {},
            method: 'get',
            header: response.data.standard_tenant_id,
          })

          yield put({
            type: 'setState',
            payload: {
              agentList: res?.data?.list || [],
            },
          })
        }
      } else {
        yield put({
          type: 'setState',
          payload: {
            enterprise: {
              scalar_num: 0,
              consume_num: 0,
            },
          },
        })
      }

      // 查询训练场插件
      yield put({ type: 'queryTools' })

      localStorage.setItem('train-user', response.data?.id)
      const id = `${response.data?.tenant_name}:${response.data?.username}`
      loginSensors(id)
      return response
    },

    *login({ payload }, { call, put, select }) {
      const role = yield select((store) => store.user.role.name)
      const response = yield call(services.login, payload)
      const id = `${response.data?.name}:${response.data?.username}`
      window.gio?.('setUserId', id) // name用于埋点分析是区分用户

      if (!response.code) {
        // response.data.role = { name: response.data.role } // 修改一下角色的格式
        if (response?.data?.many_user) return response
        yield put({
          type: 'setState',
          payload: { ...response.data, role: { name: response.data.role } },
        })

        localStorage.setItem('Tooltip', 'true')
        if (response.data.role === 'admin') {
          history.replace('/workbench/dashboard')
        } else {
          history.replace('/exam/admit/train')
        }
      }
      return response
    },

    *logout(action, { call, put }) {
      const { href, origin } = window.location
      const redirect = href.replace(origin, '')
      if (window.location.pathname !== '/user/login') {
        yield call(services.logout)
      }
      history.replace({
        pathname: '/user/login',
        search: stringify({ redirect }),
      })
      localStorage.removeItem('train-user')
    },

    *switchPlatform({ payload }, { call }) {
      const response = yield call(services.switchPlatform, payload, '切换平台成功', '切换平台失败')
      return response
    },

    *updateUserName({ payload }, { call }) {
      const response = yield call(services.updateUserName, payload)
      return response
    },

    *updatePassword({ payload }, { call }) {
      const response = yield call(services.updatePassword, payload)
      return response
    },

    *industryCategory(_, { call, put }) {
      const response = yield call(services.industryCategory)
      return response
    },

    *initUserOnce({ payload }, { call, put }) {
      const response = yield call(services.initUserOnce, payload)
      return response
    },

    *bindXHMC(_, { call }) {
      const response = yield call(services.bindXHMC)
      return response
    },

    *resetPass({ payload }, { select, call }) {
      const res = yield call(services.resetPass, payload)
      return res
    },

    // 流量信息
    *enterprise({ payload }, { call, put }) {
      const response = yield call(fetchUser, {
        url:
          window.location.host?.startsWith('localhost') ||
          window.location.host?.startsWith('dev.lane.xiaoduoai.com') ||
          window.location.host?.startsWith('training-dev-lane')
            ? 'https://console-dev-lane.xiaoduoai.com/flow/v2/scalar/cycle/enterprise'
            : 'https://console.xiaoduoai.com/flow/v2/scalar/cycle/enterprise',
        data: {
          ...payload,
        },
        method: 'post',
      })

      if (response?.code === 0) {
        yield put({
          type: 'setState',
          payload: {
            enterprise: {
              scalar_num: 0,
              consume_num: 0,
              ...response.data.data,
            },
          },
        })
      }
    },
    // 获取支付url
    *fecthPayUrl({ payload }, { call, put, select }) {
      const { header, ...rest } = payload
      const { data } = yield call(fetchPayUrl, {
        url: isTest
          ? 'https://enterprise-dev-lane.xiaoduoai.com/api/app/item_by_key'
          : 'https://enterprise.xiaoduoai.com/api/app/item_by_key',
        data: {
          ...rest,
        },
        header,
      })

      const url = `${appHubUrl}/app/paying?paying_app_id=${data?.id}&paying_status=1&paying_product_key=barracks&paying_plugin_key=null`
      yield put({
        type: 'setState',
        payload: {
          payUrl: url,
        },
      })
    },

    *getUcToken({ payload }, { call, put }) {
      const response = yield call(services.getUcToken, payload)
      if (response.code === 0) {
        yield put({
          type: 'setState',
          payload: {
            uc_token: response.data?.uc_token,
          },
        })
      }
      return response
    },

    *unBind(_, { call, put }) {
      const response = yield call(services.mcUnbind)
    },

    *presetTask({ payload }, { call, put }) {
      const response = yield call(services.presetTask, payload)
      yield put({ type: 'user/fetchUserInfo' })
      yield put({ type: 'storyGroups/fetchGroups' })
    },
    // 调用机器人接口获取token
    *fetchCgateToken({ payload }, { select, call }) {
      const res = yield call(services.fetchCgateToken, payload)
      return res
    },
    // 绑定多策id
    *agentBind({ payload }, { select, call }) {
      const res = yield call(services.agentBind, payload)
      return res
    },

    *fetchTrainData(_, { call }) {
      const res = yield call(services.fetchTrainData)
      return res
    },

    // 查询训练场工具
    *queryTools({ payload }, { put, call, select }) {
      const res = yield call(services.queryTools, payload)
      let tools = []
      if (res?.data?.plugins?.length) {
        const seen = new Set()
        tools = res.data.plugins
          .filter((i) => i.custom_field)
          ?.map((i) => {
            let field
            try {
              field = { ...JSON.parse(i.custom_field), remark: i.remark }
            } catch (error) {
              field = {}
            }
            return field
          })
          .filter((item) => {
            if (seen.has(item.tool_id)) {
              return false
            } else {
              seen.add(item.tool_id)
              return true
            }
          })
        yield put({
          type: 'setState',
          payload: {
            toolList: tools || [],
          },
        })
      }
      return res
    },

    *getPlugin({ payload }, { call }) {
      const res = yield call(services.pluginCal, payload)
      return res
    },

    // 查询用户组
    *getMetadataAndGroups(_, { call, put }) {
      const response = yield call(services.getMetadata)
      yield put({
        type: 'setState',
        payload: {
          schema_definition: response.data.schema_definition || [],
        },
      })
      return response.data.schema_definition
    },
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload }
    },
  },
}
export default UserModel
